import { React, useState, useEffect } from "react";
import Emulator from "../components/emulator/Emulator";
import { RightOutlined, LeftOutlined, HomeOutlined } from "@ant-design/icons";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { routes } from "../const";
import { getSubtask } from '../tasks';
import "../components/emulator/TaskBody.css";

export default function Subtask() {
    const { task, branchid } = useParams();
    const locState = useLocation();
    const navigate = useNavigate();

    const [ subtaskid, setSubtaskid ] = useState(-1);
    const [ SM, setSM ] = useState([{}]);
    const [ loading, setLoading ] = useState(true);
    const [ tries, setTries ] = useState(0);
    const [ state, setState ] = useState(0);

    useEffect(() => {
        getSubtask(task, branchid)
            .then(data => {
                if (data) {
                    setSM(data.taskSM);
                    setSubtaskid(data.id);
                    setLoading(false);
                    return data.taskSM;
                } else {
                    navigate(routes.NOT_FOUND);
                    return;
                }
            })
            .then(taskSM => {
                // preload images
                Object.values(taskSM).forEach(
                    (e) => new Image().src = e.img
                );
            });
        
        if (locState.state != null) {
            if (locState.state.jump != null) {
                setState(locState.state.jump);
            }
        }

    }, []);

    const advanceState = () => {
        if (state < (SM.length - 1))
            setState(state + 1);
    };

    const stepBackState = () => {
        dataLogger(tries);
        if (state === 0) {
            navigate(routes.TASK.replace(":task", task), { state: { jump: -1 }});
        }
        if (state > 0)
            setState(state - 1);
    };

    const dataLogger = (tries) => {
        const old = window.sessionStorage.getItem("log");
        const data = {subtask: subtaskid, state: state, clicks: tries};
        if (old) {
            window.sessionStorage.setItem("log", JSON.stringify([...JSON.parse(old), data]));
        } else {
            window.sessionStorage.setItem("log", JSON.stringify([data]));
        }
    };

    return (
        <>
        <Spin className="absolute z-10 w-full" size="large" spinning={loading} />
        <div className="story flex flex-col-reverse items-center" style={{ backgroundImage: "url(/kueh-shop-transparent.jpg)"}}>
            
            <div className="basis-1/6 p-8 relative shrink-0 bg-indigo-700 w-full">

                <p className="text-2xl text-white italic">{ SM[state].instruction }</p>
                <div className="mt-12"> 
                    <a className="absolute left-0 bottom-0 m-8 z-10">
                        <LeftOutlined onClick={ () => stepBackState() } style={{ fontSize: '30px', color:"#ffffff" }} /> 
                    </a>
                    
                    <div className="absolute bottom-0 m-8 inset-x-0 text-center">
                        <Link to={routes.TASK_SELECTION}>
                            <HomeOutlined style={{ fontSize: '30px', color:"#ffffff"}} />
                        </Link>
                    </div>

                    { SM[state].fin && 
                    <Link to={routes.COMPLETION.replace(":task", task)} className="absolute right-0 bottom-0 m-8">
                        <RightOutlined style={{ fontSize: '30px', color:"#ffffff"}} />
                    </Link> }
                </div>

            </div>

            { !loading && <Emulator
                state={ SM[state] }
                updateState={ advanceState }
                logger={ dataLogger } 
                setParentTries={ setTries }
                />
            }
        </div>
        </>
    );
}